export const REFERRAL_GET_REQUEST = 'REFERRAL_GET_REQUEST';
export const REFERRAL_GET_SUCCESS = 'REFERRAL_GET_SUCCESS';
export const REFERRAL_GET_ERROR = 'REFERRAL_GET_ERROR';
